import { Component, Inject, OnInit } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { TranslateService } from "@ngx-translate/core";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { JackpotChangeThresholdComponent } from "../jackpot-change-threshold/jackpot-change-threshold.component";
import { SyndicateRepositoryService } from "../syndicate-repository.service";
import { IonicModule } from "@ionic/angular";
import { NgClass } from "@angular/common";

@Component({
    selector: "app-syndicate-jackpot-popup",
    templateUrl: "./syndicate-jackpot-popup.component.html",
    styleUrls: ["./syndicate-jackpot-popup.component.scss"],
    standalone: true,
    imports: [IonicModule, NgClass],
})
export class SyndicateJackpotPopupComponent implements OnInit {
  matDialog: any;
  jackpotTrigger: any;
  translatedData: any;
  translatedToastMsg: any;
  selectedLanguage: string = "en";

  constructor(
    private matDialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) public triggerData: any,
    private dialog: MatDialogRef<SyndicateJackpotPopupComponent>,
    private syndicateService: SyndicateRepositoryService,
    private snackService: MySnackBarService,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private jackpotTriggerService: JackpotTriggersService,
    public translate: TranslateService,
    public matBottomSheet: MatBottomSheet,
  ) {
    this.authService.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
  }

  ngOnInit(): void {
    this.jackpotTrigger = this.triggerData;
    this.jackpotTriggerService.storeJackpotData(this.jackpotTrigger);
    try {
      this.authService.userDetails$.subscribe((user: any) => {
        const languageCode = user?.language_code ? user?.language_code : "en";
        this.jackpotTriggerService?.getTranslatedData(languageCode)?.subscribe(
          (data) => {
            this.translatedData = data?.["turn-off-jackpot-trigger"];
          },
          (err) => {
            return err;
          }
        );
      });
    } catch (e) { return e }
  }

  closeBox() {
    this.matDialogRef.closeAll();
    this.dialog.close(true);
  }

  deactivateTrigger() {
    this.matBottomSheet.open(JackpotChangeThresholdComponent, {
      panelClass: "syndicate-jackpot-bottomsheet",
      backdropClass: "about-product-dialog-backdrop",
    });
    this.closeBox();
  }
}
